import { EventMasterEditorApp } from "./main";
import { registerComponent } from "lib/components";

registerComponent({ EventMasterEditorApp });
